import { Component } from '@angular/core';
import { SystemSiteService } from 'app/services/system-site.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-testimonial-detail',
  templateUrl: './testimonial-detail.component.html',
  styleUrls: ['./testimonial-detail.component.scss']
})
export class TestimonialDetailComponent {
  Data: any = [];

  testimonialSubscription: Subscription = null;
  parameterSubscription: Subscription = null;

  public result_message = ""
  constructor(private systemSiteService: SystemSiteService, private router: Router, private route: ActivatedRoute) { }



  ngOnInit() {
    this.parameterSubscription = this.route.params.subscribe(params => {
      this.testimonialSubscription = this.systemSiteService.get_testimonial(params._id).subscribe({
        next: (data) => {
          console.log(data.result_data)
          this.Data = data.result_data;

        },
        error: (error) => { console.log(error) },
      })
    });


  }

  ngOnDestroy(): void {
    if (this.testimonialSubscription)
      this.testimonialSubscription.unsubscribe();
    if (this.parameterSubscription)
      this.parameterSubscription.unsubscribe();
  }



}